const awsmobile = {
  switching_endpoint: "https://api-staging.switching.prod.trustpower.io",
  api_key: "d421367489805f907107f0e1f6f66fc6LXN0YWdpbmc=",
};

export default awsmobile;
